const Logo = (props) => (
  <img
    alt="Logo"
    src="https://koalaliving.com.au/_next/image?url=%2FKL-White.png&w=256&q=100"
    {...props}
    width={100}
  />
);

export default Logo;
